import React, {useCallback, useEffect} from 'react'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import {useRouter} from 'next/router'
import Script from 'next/script'
import {useLoginStore} from '@store/LoginStore'

const APP_ID = 'hj8u3hqb'

const IntercomSetting = () => {
    const {data: me} = useQueryFetchMe(undefined)
    const loginUserId = useLoginStore(state => state.id)
    const router = useRouter()
    // 2025.02.10 수정

    // Intercom 초기화를 별도 함수로 분리
    const initializeIntercom = useCallback(() => {
        // /chart 페이지에서는 Intercom을 표시하지 않음
        if (router?.asPath.includes('/chart')) {
            if (typeof window?.Intercom === 'function') {
                window?.Intercom('hide')
            }
            return
        }

        // 기존 인스턴스가 있다면 종료
        if (typeof window?.Intercom === 'function') {
            window?.Intercom('shutdown')
        }

        // Intercom 설정 적용
        if (me && loginUserId) {
            window.intercomSettings = {
                app_id: APP_ID,
                email: me?.email,
                name: me?.name,
                phone: me?.phone,
                created_at: me?.created_at,
                user_id: me?.id,
                ads_msg_night_enabled: me?.preferences?.ads_msg_night_enabled === 1,
                name_ko: me?.nicknames?.at(0)?.nickname,
                ads_msg_enabled: me?.preferences?.ads_msg_enabled === 1,
                language_override: router?.locale || 'en',
                avatar: {
                    type: 'avatar',
                    image_url: me?.thumbnail,
                },
            }
        } else {
            window.intercomSettings = {
                app_id: APP_ID,
            }
        }

        // Intercom 부트 로직
        if (typeof window?.Intercom === 'function') {
            window?.Intercom('reattach_activator')
            window?.Intercom('boot', window?.intercomSettings)
        }
    }, [me, loginUserId, router?.asPath, router?.locale])

    // idle 타임에 실행: requestIdleCallback 지원 여부에 따라 fallback 처리
    const runWhenIdle = fn => {
        if (typeof window?.requestIdleCallback === 'function') {
            window?.requestIdleCallback(fn)
        } else {
            // requestIdleCallback이 없으면 200ms 후 실행
            setTimeout(fn, 200)
        }
    }

    // 스크립트 로드 완료 시에도 idle 시간에 초기화
    const handleScriptLoad = useCallback(() => {
        runWhenIdle(() => {
            initializeIntercom()
        })
    }, [initializeIntercom])

    // 의존성(사용자 정보, 로그인 상태, locale, 경로)이 바뀔 때 idle 타임에 재실행
    useEffect(() => {
        // Intercom 스크립트가 로드된 후에 초기화가 실행되도록 함.
        if (typeof window?.Intercom === 'function') {
            runWhenIdle(() => {
                initializeIntercom()
            })
        }
    }, [initializeIntercom])
    // ------------

    // intercomSettings 설정 (2025.02.10 이전)
    // useEffect(() => {
    //     if (!!window?.Intercom) {
    //         //@ts-ignore
    //         window?.Intercom('shutdown')
    //     }
    //     if (me && loginUserId) {
    //         if (router?.asPath.includes('/chart')) return
    //         window?.intercomSettings = {
    //             app_id: APP_ID,
    //             email: me?.email,
    //             name: me?.name,
    //             phone: me?.phone,
    //             created_at: me?.created_at,
    //             user_id: me?.id,
    //             ads_msg_night_enabled: me?.preferences?.ads_msg_night_enabled === 1,
    //             name_ko: me?.nicknames?.at(0)?.nickname,
    //             ads_msg_enabled: me?.preferences?.ads_msg_enabled === 1,
    //             language_override: router?.locale || 'en',
    //             avatar: {
    //                 type: 'avatar',
    //                 image_url: me?.thumbnail,
    //             },
    //         }
    //     } else {
    //         if (router?.asPath.includes('/chart')) return
    //         window?.intercomSettings = {
    //             app_id: APP_ID,
    //         }
    //     }
    //
    //     if (typeof window?.Intercom === 'function') {
    //         if (router?.asPath.includes('/chart')) {
    //             window?.Intercom('hide')
    //             return
    //         }
    //
    //         window?.Intercom('reattach_activator')
    //         if (me && loginUserId) {
    //             window?.Intercom('boot', window?.intercomSettings)
    //         } else {
    //             window?.Intercom('boot', window?.intercomSettings)
    //         }
    //     }
    // }, [me, router.locale, loginUserId, router?.asPath])

    return (
        <>
            <Script
                src={`https://widget.intercom.io/widget/${APP_ID}`}
                strategy="lazyOnload"
                crossOrigin={'anonymous'}
                onLoad={handleScriptLoad}
            />
        </>
    )
}
export default IntercomSetting
